// extracted by mini-css-extract-plugin
export default {"App":"_Contact_App__wa4sG","contact_page":"_Contact_contact_page__1kCYc","grid":"_Contact_grid__ymgAq"};